// 화면1 — 권고 조건 생성 더미 데이터
import { computeParams, recommendedParams } from './params';

// 권고 케이스 목록 (좌측 리스트) — 각 케이스는 특정 제품(샷)에 대한 AI 권고 1건
// params: 해당 케이스의 파라미터 현재값→권고값 세트
// status: 권고 처리 상태 (대기/승인/적용)
export const recommendationCases = [
  {
    id: 'REC-2048',
    shotId: 'S-10248',
    productId: 'P-8848',
    ts: '2026-07-13 14:32:08',
    defectKeys: ['warpage', 'shrinkage'],
    predictedReduction: -30,
    confidence: 92.4,
    status: 'pending',
    noteKey: 'pages.modulec.recommend.notes.rec2048',
    params: recommendedParams, // 정본(세이프가드 화면과 동일)
  },
  {
    id: 'REC-2043',
    shotId: 'S-10243',
    productId: 'P-8843',
    ts: '2026-07-13 14:31:46',
    defectKeys: ['dimension'],
    predictedReduction: -24,
    confidence: 88.1,
    status: 'pending',
    noteKey: 'pages.modulec.recommend.notes.rec2043',
    params: computeParams([
      { key: 'injectionPressure', labelKey: 'pages.modulec.params.injectionPressure', unit: 'MPa', current: 118.0, recommended: 126.0, min: 90, max: 130, tempFactor: false },
      { key: 'injectionSpeed', labelKey: 'pages.modulec.params.injectionSpeed', unit: 'mm/s', current: 78, recommended: 88, min: 40, max: 95, tempFactor: false },
      { key: 'holdingPressure', labelKey: 'pages.modulec.params.holdingPressure', unit: 'MPa', current: 60, recommended: 69, min: 40, max: 75, tempFactor: false },
      { key: 'moldTemp', labelKey: 'pages.modulec.params.moldTemp', unit: '℃', current: 52, recommended: 54, min: 40, max: 60, tempFactor: true },
      { key: 'coolingTime', labelKey: 'pages.modulec.params.coolingTime', unit: 's', current: 18.0, recommended: 17.0, min: 12, max: 25, tempFactor: false },
    ]),
  },
  {
    id: 'REC-2041',
    shotId: 'S-10241',
    productId: 'P-8841',
    ts: '2026-07-13 14:31:38',
    defectKeys: ['warpage'],
    predictedReduction: -33,
    confidence: 93.7,
    status: 'pending',
    noteKey: 'pages.modulec.recommend.notes.rec2041',
    params: computeParams([
      { key: 'injectionPressure', labelKey: 'pages.modulec.params.injectionPressure', unit: 'MPa', current: 118.0, recommended: 122.0, min: 90, max: 130, tempFactor: false },
      { key: 'injectionSpeed', labelKey: 'pages.modulec.params.injectionSpeed', unit: 'mm/s', current: 78, recommended: 80, min: 40, max: 95, tempFactor: false },
      { key: 'holdingPressure', labelKey: 'pages.modulec.params.holdingPressure', unit: 'MPa', current: 60, recommended: 64, min: 40, max: 75, tempFactor: false },
      { key: 'moldTemp', labelKey: 'pages.modulec.params.moldTemp', unit: '℃', current: 52, recommended: 59, min: 40, max: 60, tempFactor: true },
      { key: 'coolingTime', labelKey: 'pages.modulec.params.coolingTime', unit: 's', current: 18.0, recommended: 15.5, min: 12, max: 25, tempFactor: false },
    ]),
  },
];

// 권고 케이스 상태 배지 메타
export const recCaseStatusMeta = {
  pending: { labelKey: 'pages.modulec.recCaseStatus.pending', color: '#fbbf24', bg: 'rgba(251,191,36,0.12)' },
  approved: { labelKey: 'pages.modulec.recCaseStatus.approved', color: '#22c55e', bg: 'rgba(34,197,94,0.12)' },
};

// 기본 선택 케이스
export const defaultRecCaseId = 'REC-2048';
